import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

export const useGenderOptions = () => {
    const { t } = useTranslation();

    const genderOptions = useMemo(
        () => [
            {
                label: t('common.male'),
                value: 'M',
            },
            {
                label: t('common.female'),
                value: 'F',
            },
        ],
        [t],
    );

    return genderOptions;
};
